import { connect } from 'react-redux'
import ProviderProductCreate from '../../components/products/ProviderProductCreate'
import * as actions from '../../state/actions/provider-products/index'
import { IProviderProductObject, IStoreState } from '../../types/index'

export function mapStateToProps(state: IStoreState, ownProps: any): any {
  return {
    organizationId: state.organizations.currentOrgId,
    serviceLevels: state.globalSettings.serviceLevels.items,
    history: ownProps.history
  }
}

export function mapDispatchToProps(dispatch: any) {
  return {
    onCreate: (product: IProviderProductObject) => {
      return (e: any) => {
        dispatch(actions.createProduct(product))
      }
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ProviderProductCreate)



// WEBPACK FOOTER //
// ./src/containers/products/ProviderProductCreate.ts